<div class="flex justify-evenly rtl main-menu__logo-col-title text-align-center">
	<span>{{ productName }}</span>
</div>
<mat-dialog-content class="mat-typography" dir="rtl">
	<div class="product-detail__wrapper2 custom-scrollbar">
		<table class="report-table__table no-width" cellspacing="0" style="display: table">
			<thead class="report-table__table-head">
				<tr>
					<th class="report-table__table-head-name">רמה</th>
					<th class="report-table__table-head-name">החל מ</th>
					<th class="report-table__table-head-name">מחיר</th>
				</tr>
			</thead>
			<tbody class="report-table__table-body">
				<tr *ngFor="let mivza of allMivza">
					<td class="report-table__table-body-name">{{ mivza.Level }}</td>
					<td class="report-table__table-body-name">{{ mivza.FromQty }}</td>
					<td class="report-table__table-body-name">{{ mivza.PriceGet }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button [mat-dialog-close]="true" cdkFocusInitial>סגור</button>
</mat-dialog-actions>
